import { create } from "zustand";

export type TCommentAnchorEntry = { commentId: string; range: Range; text: string };

type TCommentAnchorsStore = {
  entries: TCommentAnchorEntry[];
  setEntries: (entries: TCommentAnchorEntry[]) => void;
};

// Inline comments of a read-only (blocks) chapter located in the rendered text. The comments
// panel reads the quoted text and the jump target from here, since there is no mark in the DOM.
export const useCommentAnchorsStore = create<TCommentAnchorsStore>((set) => ({
  entries: [],
  setEntries: (entries) => set({ entries })
}));

export const findCommentAnchor = (commentId: string) =>
  useCommentAnchorsStore.getState().entries.find((entry) => entry.commentId === commentId) ?? null;
